import './QuantitativeDimensionalIndicatorFields.css';

import { generateClassName, generateSelectField } from '../../../b2b-common/helpers';
import useQuantitativeDimensionalTypes from '../../hooks/useQuantitativeDimensionalTypes';
import { MeasurementUnitSelector } from './QuantitativeIndicatorFields';
import React, { useState } from 'react';
import DimensionValuesTable from '../DimensionValuesTable';
import { List } from '@mui/icons-material';

const QuantitativeDimensionalIndicatorFields = ({ indicator, setIndicator, className = null }) => {
    const quantitativeDimensionalTypes = useQuantitativeDimensionalTypes();
    const [isListValuesHovered, setIsListValuesHovered] = useState(false);
    const isUsed = indicator && indicator.areaIndicatorDTOs && indicator.areaIndicatorDTOs.length > 0;

    if (!quantitativeDimensionalTypes) {
        return null;
    }

    const dimensionalTypesList = quantitativeDimensionalTypes.map((type) => {
        return {
            value: type.dimensionTypeId,
            label: type.dimensionTypeName
        };
    });

    return (
        <div className={generateClassName('quantitative-dimensional-indicator-fields', '', className)}>
            <MeasurementUnitSelector indicator={indicator} setIndicator={setIndicator} className={className} />
            <div className='quantitative-indicator-dimensions-selector'>
                {generateSelectField(dimensionalTypesList,
                    {
                        label: 'Dimensional Type',
                        value: indicator.dimensionalType?.dimensionTypeId,
                        onChange: (event) => setIndicator({
                            ...indicator,
                            dimensionalType: quantitativeDimensionalTypes.find((type) => type.dimensionTypeId === event.target.value)
                        }),
                        className: 'quantitative-indicator-dimensional-type',
                        disabled: isUsed
                    }
                )}
                <div
                    onMouseOver={() => setIsListValuesHovered(true)}
                    onMouseOut={() => setIsListValuesHovered(false)}
                    className='qualitative-indicator-dimensional-list-values-icon'
                >
                    <List />
                </div>
                {isListValuesHovered && (
                    <div className='qualitative-indicator-dimensional-list-values-tooltip'
                        style={{ height: 'auto' }}
                    >
                        <DimensionValuesTable dimensionValues={indicator.dimensionalType?.dimensionValues} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default QuantitativeDimensionalIndicatorFields;